import {writable} from 'svelte/store';
import {I_PROMOTION} from "../../../../../lib/datatypes";
import {sortCompareASC, sortCompareDESC} from "../../../../../lib/utils";

export const promotions = writable({
    list: [],
    lookup: {},
});
export const promotions_fetching = writable(false);

const _createLookup = list => {
    let result = {};
    for(let i = 0, n = list.length; i < n; i++) {
        result[list[i][I_PROMOTION.ID]] = list[i];
    }
    return result;
};


const _updateStructures = promotions => {
    promotions.list.sort((a, b) => sortCompareDESC(a[I_PROMOTION.UPDATED], b[I_PROMOTION.UPDATED]));
    promotions.lookup = _createLookup(promotions.list);
};

let $promotions = null;
const unsubscribe = promotions.subscribe(val => $promotions = val);

// Explicitly set the contents of promotions by passing them in, ie from bootstrapped data
export const setPromotions = promotions_data => {
    promotions.update(promotions => {
        promotions.list = promotions_data;
        _updateStructures(promotions);
        return promotions;
    });
};

export const loadPromotions = async () => {
    promotions_fetching.set(true);

    const response = await fetch(`/api/promotions`);
    let result = await response.json();
    promotions_fetching.set(false);
    promotions.update(promotions => {
        promotions.list = result;
        _updateStructures(promotions);
        return promotions;
    });
};

export const addRawPromotion = async promotion_arr => {
    promotions_fetching.set(true);

    const url = `/api/promotion/add`;
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(promotion_arr)
    });
    let result = await response.json();
    promotions_fetching.set(false);
    promotions.update(promotions => {
        promotions.list.push(result);
        _updateStructures(promotions);
        return promotions;
    });
    return result;
};

export const updateRawPromotion = async promotion => {
    promotions_fetching.set(true);

    const url = `/api/promotion/${promotion[I_PROMOTION.ID]}/update`;
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(promotion)
    });
    let result = await response.json();
    // console.log(response, result);
    // ..update local copy of promotions with the updated data - could just download the data again (server would have updated data), but..
    const i = $promotions.list.findIndex(el => el[I_PROMOTION.ID] === promotion[I_PROMOTION.ID]);
    promotions_fetching.set(false);
    promotions.update(promotions => {
        promotions.list[i] = result;  // @ASSUMPTION that the result will always contain a successful object, ie doesn't handle errors
        _updateStructures(promotions);
        return promotions;
    });
    return result;
};